import React, { useContext } from 'react';
import { SettingsContext } from '../context/SettingsContext';

interface ContentAreaProps {
  children: React.ReactNode;
}

const ContentArea: React.FC<ContentAreaProps> = ({ children }) => {
  const { collapsed } = useContext(SettingsContext);

  return (
    <div className="ContentArea" style={{ marginLeft: collapsed ? '-190px' : '20px', transition: 'margin-left 0.3s' }}>
      {children}
    </div>
  );
}

export default ContentArea;
